import { useEffect, useLayoutEffect, useState, useSyncExternalStore } from 'react';
import { useRuntime } from '@/app/providers/runtime-provider';
import { UploadController, type UploadHandlers } from './upload-controller';
import type { UploadRow } from './upload-model';

export interface Uploads {
  controller: UploadController;
  rows: readonly UploadRow[];
}

/**
 * The uploads of a screen: one controller (and so one Uppy instance, created with the first file)
 * for as long as the screen is mounted. Leaving the screen cancels the files still being sent.
 */
export function useUploads(handlers: UploadHandlers = {}): Uploads {
  const { fetcher } = useRuntime();
  const [controller] = useState(() => new UploadController({ fetcher }));
  const rows = useSyncExternalStore(controller.subscribe, controller.getSnapshot);

  useLayoutEffect(() => {
    controller.setHandlers(handlers);
  });
  useEffect(() => {
    controller.attach();
    return () => {
      controller.destroy();
    };
  }, [controller]);

  return { controller, rows };
}
